import LogoSpinner from 'common/components/logoSpinner/LogoSpinner';
import { useStores } from 'common/hooks/useStores';
import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import './login.scss';
import { useNavigate } from 'react-router';
import { IAuthSettings } from 'stores/AuthStore';

const K1Login = () => {
    const { authStore } = useStores();
    const navigate = useNavigate();

    const { k1AuthorizationUrl } = authStore.settings as IAuthSettings;
    const urlParams = new URLSearchParams(window.location.search);

    useEffect(() => {
        if (!k1AuthorizationUrl) {
            //redirect to login page
            navigate('/login');
            return;
        }

        if (urlParams.has('login_hint')) {
            const url = new URL(k1AuthorizationUrl as string);
            const state = url.searchParams.get('state');
            sessionStorage.setItem('k1State', state || '');
            window.location.href = k1AuthorizationUrl as string;
        }
    });

    return <LogoSpinner />;
};

export default observer(K1Login);
